import { Badge } from '../components/ui/badge';
import { STATUS_LABELS, ALERT_LEVELS, CATEGORY_LABELS } from '../api/demoData';

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return '—'; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch { return '—'; }
};

const STATUS_COLORS = {
  brouillon: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  soumise: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300',
  analyse_risques: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300',
  approbation: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  implementation: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  pret_cloture: 'bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300',
  cloturee: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
  annulee: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
};

export function StatusBadge({ status, label }) {
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-semibold ${STATUS_COLORS[status] || STATUS_COLORS.brouillon}`}>
      {label || STATUS_LABELS[status] || status}
    </span>
  );
}

export function AlertBadge({ level }) {
  const a = ALERT_LEVELS[level] || ALERT_LEVELS.none;
  return (
    <span data-testid={`alert-badge-${level}`}
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-semibold ${a.color}`}>
      {a.label}
    </span>
  );
}

export function CategoryBadge({ category }) {
  const map = {
    1: 'bg-red-600 text-white', 2: 'bg-amber-500 text-white', 3: 'bg-slate-500 text-white',
  };
  if (!category) {
    return <span className="inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-semibold bg-muted text-muted-foreground">À classer</span>;
  }
  return (
    <span className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-bold ${map[category] || map[3]}`}>
      {CATEGORY_LABELS[category] || `Cat. ${category}`}
    </span>
  );
}
